import { render, staticRenderFns } from "./Audiobook.vue?vue&type=template&id=2da272d3&"
import script from "./Audiobook.vue?vue&type=script&lang=js&"
export * from "./Audiobook.vue?vue&type=script&lang=js&"
import style0 from "./Audiobook.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports